import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/kv.png'


const _withScopeId = n => (_pushScopeId("data-v-3a677550"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "square_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "square_container_img_wrap" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "square_container_img",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_2 = { class: "square_meta" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "square_meta_tbody meta_info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "square_meta_tbody_title" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text" }, "直播间01")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "square_meta_tbody_desc" }, "2021-04-12 14：44")
], -1))
const _hoisted_4 = { class: "square_meta_tbody" }
const _hoisted_5 = { class: "square_wrap_tab" }
const _hoisted_6 = { class: "item_select_arrow" }

import { computed, reactive } from 'vue';
import type { RootLive } from '@/store/modules/live/types';
import LiveTab from '@/components/liveItem/LiveTab.vue';
interface IProps {
  dataSource: RootLive;
  checked_select?: boolean;
  selected?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'roomLower',
  props: {
    dataSource: null,
    checked_select: { type: Boolean },
    selected: { type: Boolean }
  },
  emits: ['select:changeItemMark'],
  setup(__props: any, { emit }) {

const props = __props as {
  dataSource: RootLive;
  checked_select?: boolean;
  selected?: boolean;
};


const data = reactive(props.dataSource);
const isSelect = computed(() => (props.checked_select ? 'item_select' : ''));
const isSelected = computed(() => (props.selected ? 'item_selected' : ''));

const setItemSelect = () => {
  if (props.checked_select) {
    emit('select:changeItemMark', data);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["square_wrap", [_unref(isSelect), _unref(isSelected)]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (setItemSelect()))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(LiveTab, {
          tabType: "status",
          size: "sm"
        }),
        _createVNode(LiveTab, {
          icon: "tab_type_peoples",
          type: "info",
          size: "sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("1000")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(LiveTab, {
        tabType: "mode",
        size: "lg"
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_svg_icon, {
        class: "item_select_arrow_icon",
        "icon-class": "checked"
      })
    ])
  ], 2))
}
}

})